"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const Icon_1 = require("../Icon");
require("./button.scss");
const defaultProps = {
    "data-testid": "tecma-button",
    size: "medium",
};
const Button = (_a) => {
    var { onClick, rounded, disabled, transparent, secondary, outlined, children, iconName, rightIcon, size, fluid, iconSize, link, className } = _a, rest = __rest(_a, ["onClick", "rounded", "disabled", "transparent", "secondary", "outlined", "children", "iconName", "rightIcon", "size", "fluid", "iconSize", "link", "className"]);
    const classList = (0, classnames_1.default)("tecma-button", { rounded }, { disabled }, { transparent }, { secondary }, { outlined }, { fluid }, { link }, { "icon-on-right": rightIcon }, { [`${size}`]: size }, { "icon-only": !children && iconName }, className);
    return ((0, jsx_runtime_1.jsxs)("button", Object.assign({ type: "button", onClick: onClick, className: classList, disabled: disabled }, rest, { children: [iconName && (0, jsx_runtime_1.jsx)(Icon_1.Icon, { iconName: iconName, size: iconSize || size }), children] })));
};
Button.defaultProps = defaultProps;
exports.default = Button;
